// Keep in sync with @fv/google-ai ai-models.ts
export const aiModels = [
  'gemini-3-flash-preview', // No EOL
  'gemini-3.5-flash-lite',
  'gemini-3.1-flash-lite', // EOL May 2027
  // --------------------------------
  'gemini-3.1-flash-image', // No EOL, ~2x $$ as 2.5-flash-image
  'gemini-3.8-flash', // No EOL
] as const

export type AIModel = (typeof aiModels)[number]

export const chatAiModels = [
  'gemini-3-flash-preview',
  'gemini-3.8-flash',
] as const satisfies readonly AIModel[]

export type ChatAIModel = (typeof chatAiModels)[number]

export const normalizeAIModel = <TModel extends AIModel>(
  model?: TModel,
  defaultModel?: TModel,
): TModel => (model && aiModels.includes(model) ? model : defaultModel)
